import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';

function recordCalls(state: boolean = false, action: Actions): boolean {
  switch (action.type) {
    case getType(actions.setRecordCalls):
      return action.payload
  }

  return state
}

export default combineReducers({
  recordCalls,
})

function getRoot(state: StoreState) { return state.janusExtra }

export function selectRecordCalls(state: StoreState) {
  return getRoot(state).recordCalls
}
